import { createMuiTheme } from '@material-ui/core'
declare module '@material-ui/core/styles/createMuiTheme' {
  interface Theme {
    header: {
      height: number
      bg: string
      color: string
    }
    sidebar: {
      width: number
      bg: string
      fontColor: string
    }
    custom: {
      button: {
        defaultWidth: number
      }
    }
  }

  interface ThemeOptions {
    header: {
      height: number
      bg: string
      color: string
    }
    sidebar: {
      width?: number
      bg?: string
      fontColor?: string
    }
    custom: {
      button: {
        defaultWidth: number
      }
    }
  }
}

export default createMuiTheme({
  header: {
    height: 64,
    bg: '#fff',
    color: '#222b45'
  },
  sidebar: {
    width: 224,
    bg: '#091a7a',
    fontColor: '#fff'
  },
  palette: {
    primary: {
      light: '#84a9ff',
      main: '#3366ff',
      dark: '#1939b7'
    },
    secondary: {
      light: '#ff7363',
      main: '#ff3330',
      dark: '#b71831'
    },
    background: {
      default: '#ededef'
    },
    text: {
      primary: '#222b45',
      secondary: '#66729c'
    }
  },
  typography: {
    fontSize: 13
  },
  custom: {
    button: {
      defaultWidth: 150
    }
  }
})
